namespace TabAurous.ProductDevelopment {
    export namespace RequirementStoneItemsService {
        export const baseUrl = 'ProductDevelopment/RequirementStoneItems';

        export declare function Create(request: Serenity.SaveRequest<RequirementStoneItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<RequirementStoneItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<RequirementStoneItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<RequirementStoneItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/RequirementStoneItems/Create",
            Update = "ProductDevelopment/RequirementStoneItems/Update",
            Delete = "ProductDevelopment/RequirementStoneItems/Delete",
            Retrieve = "ProductDevelopment/RequirementStoneItems/Retrieve",
            List = "ProductDevelopment/RequirementStoneItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>RequirementStoneItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
